export default __webpack_public_path__ + "static/media/img6.e3e0024e.jpg";